import { Box, SxProps, Theme, Typography } from "@mui/material";
import {
  woCardDetailFieldRowSx,
  woCardDetailLabelSx,
  woCardDetailBoldValueSx,
} from "../models/workOrderStyles";

interface WorkOrderCardDetailFieldProps {
  label: string;
  value: React.ReactNode;
  sx?: SxProps<Theme>;
}

const WorkOrderCardDetailField = ({
  label,
  value,
  sx,
}: WorkOrderCardDetailFieldProps) => {
  const boxSx: SxProps<Theme> = sx
    ? [woCardDetailFieldRowSx, ...(Array.isArray(sx) ? sx : [sx])]
    : woCardDetailFieldRowSx;

  return (
    <Box sx={boxSx}>
      <Typography component="span" sx={woCardDetailLabelSx}>
        {label}
      </Typography>{" "}
      <Typography component="span" sx={woCardDetailBoldValueSx}>
        {value}
      </Typography>
    </Box>
  );
};

export default WorkOrderCardDetailField;
